export default {
  success: 'success',
  loading: 'loading',
  error: 'error',
  initial: 'initial',
}
